import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters from './__generated__/PolarisProjectArchivedIdeasPageQuery$parameters.ts';
import type { PolarisProjectArchivedIdeasPageQuery } from './__generated__/PolarisProjectArchivedIdeasPageQuery.graphql.ts';
import type { PolarisProjectArchivedIdeasEntryPointProps } from './polarisProjectArchivedIdeasEntryPoint.entrypoint.types.tsx';

type PolarisProjectArchivedIdeasEntryPointComponent = EntryPointComponent<
	{ projectQuery: PolarisProjectArchivedIdeasPageQuery },
	{},
	{},
	PolarisProjectArchivedIdeasEntryPointProps
>;

export const polarisProjectArchivedIdeasEntryPoint: EntryPoint<
	PolarisProjectArchivedIdeasEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<PolarisProjectArchivedIdeasEntryPointComponent>(
		/* webpackChunkName: "async-polaris-project-archived-ideas", jiraSpaEntry: "async-polaris-ideas" */ './PolarisProjectArchivedIdeasPage.tsx',
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey;

		if (!projectKey) {
			throw new Error('Invarinat: Route is configured to alwyas contain project key');
		}

		return {
			queries: {
				projectQuery: {
					parameters,
					variables: {
						cloudId,
						projectKey,
					},
				},
			},
			extraProps: { projectKey },
		};
	},
});
